export const INITIAL_FORM_STATE = {
  id: null,
  type: "",
  title: "",
  description: "",
  start: "",
  end: "",
  startTime: "09:00",
  endTime: "18:00",
  allDay: true,
  visibility: "Global",
  scopeValues: [],
};

export function getInitialFormState() {
  return {
    ...INITIAL_FORM_STATE,
    scopeValues: [...INITIAL_FORM_STATE.scopeValues],
  };
}
